import type {FocalPointAsset, FromResolver} from "#magnolia-layer/types/magnolia-types";
import {computeExtractionArea} from "#base-layer/utils/ipx/computeExtractionArea";
import {mediaMinWidth} from "#base-layer/utils/image/mediaMinWidth";
import type {ImageModifiers} from "@nuxt/image";

export type ResolvedFocalPointAsset = {
  sizes: string | undefined;
  src: string;
  media: string | undefined;
  srcset: string;
  type: string | undefined
};

export const imageToExtractionArea = (
  image: FromResolver<FocalPointAsset> | undefined,
  aspectRatio: number
) => {
  if (!image) return;
  if (typeof image === 'string') return;
  if (!image.metadata) return;
  if (image.metadata.width < 1) return;
  if (image.metadata.height < 1) return;
  const w = image.metadata.width;
  const h = image.metadata.height;
  return computeExtractionArea(w, h, aspectRatio, image.focal?.point);
}


export const useFocalPointAsset = (asset: FocalPointAsset, aspectRatio: number, config?: {
  sizes?: string,
  modifiers?: Partial<Omit<ImageModifiers, 'extract'> & { extract: never }>
  sourceTransformation?: (asset: FocalPointAsset) => string
}): ResolvedFocalPointAsset => {
  const img = useImage();
  const extract = imageToExtractionArea(asset, aspectRatio)
  const source = config?.sourceTransformation ? config.sourceTransformation(asset) : asset["@link"];
  if (!source) throw new Error(`No source found for asset: '${asset["@id"]}'`);

  const imageSizes = img.getSizes(source, {
    sizes: config?.sizes,
    modifiers: {
      ...config?.modifiers,
      extract,
    }
  });
  return {
    ...imageSizes,
    type: config?.modifiers?.format ? `image/${config.modifiers.format}` : undefined,
    media: mediaMinWidth(imageSizes)
  }
}
